/* eslint-disable max-len */
export type FAQ = { question: string; answerParagraphs: Paragraph[] };

type Paragraph = { type: 'text'; content: string } | { type: 'bullets'; content: string[] };

export const faqs: FAQ[] = [
  {
    question: 'What is IBS?',
    answerParagraphs: [
      {
        type: 'text',
        content:
          'You may know that IBS can lead to abdominal pain, abdominal bloating, increased gas, and constipation or diarrhea.',
      },
      {
        type: 'text',
        content:
          'But did you know that IBS is classified as a disorder of the gut-brain interaction?¹',
      },
    ],
  },
  {
    question: 'What does this mean for you?',
    answerParagraphs: [
      {
        type: 'text',
        content:
          'This means that your IBS is not just about what’s going on in your gut. Your brain also plays a big role in your symptoms.',
      },
      {
        type: 'text',
        content:
          'The gut-brain axis is a two-way communication superhighway that controls your bowel movements, how you experience gut pain, and even that feeling of butterflies in your stomach – so any miscommunication between your gut and your brain can make a negative impact.',
      },
    ],
  },
  {
    question: 'What can you do?',
    answerParagraphs: [
      {
        type: 'text',
        content:
          'While dietary and simple lifestyle changes may be helpful in managing your symptoms, you still need to address the gut-brain interaction itself.',
      },
      {
        type: 'text',
        content:
          'Science has shown that one of the best ways to ‘fix’ gut-brain miscommunications is through what’s known as gut-directed hypnotherapy (GDH).',
      },
      {
        type: 'text',
        content:
          'GDH works by improving the signals between your gut and brain to reduce pain sensations, improve bowel movements, and calm your IBS-related stress and anxiety.',
      },
    ],
  },
  {
    question: 'How can we help you?',
    answerParagraphs: [
      {
        type: 'text',
        content:
          'We partnered with Dr. Simone Peters from Monash University to turn her research protocol into a mobile app called Nerva.',
      },
      {
        type: 'text',
        content:
          'In her research study comparing GDH to the low FODMAP diet, it showed that GDH alone led to a 72% reduction in overall gastrointestinal symptoms, including abdominal bloating and excessive wind.²',
      },
    ],
  },
  {
    question: 'How does Nerva help you?',
    answerParagraphs: [
      {
        type: 'text',
        content:
          'Nerva is a simple, easy-to-use six-week program you can follow from an app on your phone. It consists of daily 15-minute hypnotherapy sessions, educational readings about IBS, and breathing exercises.',
      },
      {
        type: 'text',
        content:
          'It also helps you track your physical IBS symptoms, such as pain, bloating, and stool consistency, as well as your stress and anxiety levels, which we now know plays a big part in IBS.',
      },
    ],
  },
  {
    question: 'How effective is Nerva?',
    answerParagraphs: [
      {
        type: 'text',
        content:
          'Nerva is used globally by over 150,000 people and referred by more than 5,000 healthcare providers to their patients.',
      },
      {
        type: 'bullets',
        content: [
          '89% of people who complete the Nerva program better manage their gastrointestinal symptoms.³',
          '82% of people who complete the Nerva program better manage their stress and anxiety.⁴',
        ],
      },
    ],
  },
  {
    question: 'What are the benefits of Nerva?',
    answerParagraphs: [
      {
        type: 'text',
        content:
          'Clinical psychologists that deliver GDH are hard to come by, so we built Nerva to make it more accessible, cost-effective, and standardized.',
      },
      {
        type: 'text',
        content: 'The benefits of Nerva include:',
      },
      {
        type: 'bullets',
        content: [
          'You can do it from the comfort of your own home.',
          'It’s significantly cheaper than ongoing in-person therapies and you can start right now.',
          'It works because it addresses the root cause of IBS in the gut-brain axis.',
        ],
      },
    ],
  },
];
